import { Component, input, ViewEncapsulation } from '@angular/core';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

/**
 * Componente reutilizable de overlay de carga
 * Muestra un spinner centrado con el color corporativo GIROP
 *
 * Uso:
 * <app-loading-overlay [blocked]="loading()" />
 */
@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [BlockUIModule, ProgressSpinnerModule],
  template: `
    <p-blockUI [blocked]="blocked()">
      <div class="fixed inset-0 flex items-center justify-center">
        <p-progressSpinner
          strokeWidth="4"
          fill="transparent"
          animationDuration=".8s"
          styleClass="girop-spinner"
        >
        </p-progressSpinner>
      </div>
    </p-blockUI>
  `,
  styles: [
    `
      .girop-spinner .p-progressspinner-circle {
        stroke: #2d6df6 !important;
      }
      :host ::ng-deep .p-progressspinner-circle {
        stroke: #2d6df6 !important;
      }
    `
  ],
  encapsulation: ViewEncapsulation.None
})
export class LoadingOverlayComponent {
  /** Indica si debe mostrarse el overlay bloqueante */
  blocked = input<boolean>(false);
}
